import { createApp } from 'vue';
import { createStore } from '@/store';
import globals from '@/globals';
import App from '@/App.vue';
import { createRouter } from '@/router';
import { createStaticRouter, getMatchedRoutes } from '@/router-custom/router';
import Button from '@/components/lib/button/Button.vue';
import Checkbox from '@/components/lib/checkbox/Checkbox.vue';
import Chip from '@/components/lib/chip/BaseChip.vue';
import DatePicker from '@/components/lib/date-picker/BaseDatePicker.vue';
import IDateFlatpickr from '@/components/lib/date-picker/IDateFlatpickr.vue';
import IDateSelect from '@/components/lib/date-picker/IDateSelect.vue';
import Dropdown from '@/components/lib/dropdown/Dropdown.vue';
import ITextFieldEditable from '@/components/lib/text-field/ITextFieldEditable.vue';
import Icon from '@/components/lib/icon/Icon.vue';
import MenuAction from '@/components/lib/dropdown/MenuAction.vue';
import MenuList from '@/components/lib/dropdown/MenuList.vue';
import MenuListItem from '@/components/lib/dropdown/MenuListItem.vue';
import Modal from '@/components/lib/modal/Modal.vue';
import ProgressBar from '@/components/lib/progress-bar/ProgressBar.vue';
import SplitButton from '@/components/lib/split-button/SplitButton.vue';
import TreeView from '@/components/lib/tree-view/TreeView.vue';
import VisuallyHidden from '@/components/lib/checkbox/VisuallyHidden.vue';
/**
 * @deprecated
 */
// eslint-disable-next-line
function legacyCloseEntities(store, event) {
  const { target } = event;
  const list = [
    {
      path: 'left_menu/collapseMenu',
      parent: '#imperia_main_menu',
      target: '.imenu_level2',
      props: null,
    },
  ];

  list.forEach((item) => {
    const match = !target.closest(item.parent) || target.closest(item.target);

    if (match) {
      store.dispatch(item.path, item.props);
    }
  });
}

function legacyAddGlobalListeners(store) {
  globals.context.addEventListener('click', (event) => legacyCloseEntities(store, event));
}

const imperiaUILib = {
  ITextFieldEditable,
  [Button.name]: Button,
  [Checkbox.name]: Checkbox,
  [Chip.name]: Chip,
  [DatePicker.name]: DatePicker,
  IDateFlatpickr,
  IDateSelect,
  [Dropdown.name]: Dropdown,
  [Icon.name]: Icon,
  [MenuAction.name]: MenuAction,
  [MenuList.name]: MenuList,
  [MenuListItem.name]: MenuListItem,
  [Modal.name]: Modal,
  [ProgressBar.name]: ProgressBar,
  [SplitButton.name]: SplitButton,
  [TreeView.name]: TreeView,
  [VisuallyHidden.name]: VisuallyHidden,
};

// EXPORTED
export function INIT_MODE_DEV() {
  const app = createApp(App);
  Object.entries(imperiaUILib).map((c) => app.component(...c));

  const router = createRouter();
  const store = createStore(router);

  app.use(store);
  app.use(router);
  app.mount('#app');

  legacyAddGlobalListeners(store);
}

export function INIT_MODE_PROD() {
  const router = createStaticRouter();
  const store = createStore(router);

  const { location } = globals.context;
  const systemConfig = globals.I?.settings?.system;

  getMatchedRoutes(location, systemConfig).forEach(
    ({ component, target, props }) => {
      const app = createApp(component, props);
      Object.entries(imperiaUILib).map((c) => app.component(...c));
      app.use(store);
      app.use(router);
      app.mount(target);
    },
  );

  legacyAddGlobalListeners(store);
}
